import * as ActionTypes from './types.action';

export const setFulfillmentDetails = fulfillmentDetails => ({
  type: ActionTypes.SET_FULFILLMENT_DETAILS_SUCCESS,
  fulfillmentDetails,
});
